module.exports = __webpack_public_path__ + "img/delete.412e3511.svg";